export default __webpack_public_path__ + "static/media/IconAdd.5eec68a3.svg";